import React, { useMemo, useState, useContext, createContext } from "react";
import { LightTheme, LightEspelho, LightHomologacao } from "./../themes";
import { useTitle } from "../hooks";
import { GVComponentsProvider, Theme } from "@gvdasa/react-components";

interface IThemeContextData {
  toggleTheme(): void;
  customTheme: Theme;
}

export const useThemesContext = () => useContext(ThemeContext);

const ThemeContext = createContext<IThemeContextData>({} as IThemeContextData);

export const ThemesProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { ambiente } = useTitle();

  const temaPorAmbiente = useMemo(() => {
    switch (ambiente) {
      case "dev":
        return LightTheme;
      case "esp":
        return LightEspelho;
      case "hml":
        return LightHomologacao;

      default:
        return LightTheme;
    }
  }, [ambiente]);

  const [themeData] = useState<IThemeContextData>({
    toggleTheme: () => {},
    customTheme: temaPorAmbiente,
  });

  return (
    <ThemeContext.Provider value={themeData}>
      <GVComponentsProvider theme={themeData.customTheme}>
        {children}
      </GVComponentsProvider>
    </ThemeContext.Provider>
  );
};
